import Icon from '../components/Icon.vue'

Icon.register({
  drum: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M458.1 120.9L560.5 59.4C575.6 50.4 580.5 30.7 571.4 15.5 562.3 0.4 542.7-4.5 527.5 4.6L366.8 101A629.3-629.3 0 0 1 288 96C128.9 96 0 153.3 0 224V384.8C0 415.3 24 443.2 64 465.2V368.8C64 351.2 78.4 336.8 96 336.8S128 351.2 128 368.8V491.2C165.4 502.4 209 509.7 256 512V400.8C256 383.2 270.4 368.8 288 368.8S320 383.2 320 400.8V512C367 509.7 410.6 502.4 448 491.3V368.8C448 351.2 462.4 336.8 480 336.8S512 351.2 512 368.8V465.2C552 443.2 576 415.3 576 384.8V224C576 181.6 529.5 144.2 458.1 120.9zM288 304C155.4 304 48 268.2 48 224S155.4 144 288 144C290.3 144 292.6 144.1 294.9 144.1L207.5 196.6C192.4 205.7 187.5 225.3 196.6 240.5 206.1 256.4 226.1 260.1 240.5 251.4L403.2 153.8C477.6 167.4 528 193.7 528 224 528 268.2 420.5 304 288 304z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/drum.js
// module id = 6jaI
// module chunks = 144